import { render } from "./MurmurTop.vue?vue&type=template&id=79a69e22"
import script from "./MurmurTop.vue?vue&type=script&lang=js"
export * from "./MurmurTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__